import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-reihenfolgen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenAufgabeReihenfolgenEffects {

    AufgabeReihenfolgen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_REIHENFOLGEN),
        mergeMap((x: ac.PostAufgabeReihenfolgenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeReihenfolgen(x.aufgabeIdListeRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeReihenfolgenErfolgreichAction(x.aufgabeIdListeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeReihenfolgenFehlerAction(error, x.aufgabeIdListeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
